import React from "react";
import PropTypes from "prop-types";
import Header from "components/header/header";
import ProgressBar from "components/progress-bar/progress-bar";
import Footer from "../footer/Footer";
const StepsWrapper = ({title, children, stepGroupTitle, loaded, }) => {
const className = "step-container"


    return (
        <>
            <Header title={title}/>
            <main className={className} >
                {stepGroupTitle && <ProgressBar title={stepGroupTitle} loaded={loaded} back={loaded} /> }
                <div className={stepGroupTitle === " " ? "step no-title" : "step"}>
                    {stepGroupTitle && <ProgressBar isDesktop={true} title={stepGroupTitle} loaded={loaded} back={loaded} /> }
                    <div className="step__body">
                        {children}
                    </div>
                </div>
            </main>
            <Footer/>

        </>
    )
}


StepsWrapper.propTypes = {
    name: PropTypes.string,
    children: PropTypes.any,
    stepGroupTitle: PropTypes.any,
    sectionTitle: PropTypes.any,
    loaded: PropTypes.any,
    back: PropTypes.any,
    title: PropTypes.string,
}

export default StepsWrapper